export default __webpack_public_path__ + "d47702fc514689aeadfb7d7730683acc.png";